import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { HttpService } from '../../services/http/http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { tap, switchMap, catchError } from 'rxjs/operators';
import { EMPTY} from 'rxjs';

enum EliminaStep {
  COMPETENZA = 1,
  ASSOCIAZIONI = 2,
}

@Component({
  selector: 'app-elimina-competenza',
  templateUrl: './elimina-competenza.component.html',
  styleUrls: ['./elimina-competenza.component.scss'],
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  standalone: true,
})
export class EliminaCompetenzaComponent {
  constructor(
    public dialogRef: MatDialogRef<EliminaCompetenzaComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { idCompetenza: number;},
    public api: HttpService,
    public snackBar: MatSnackBar,
  ) {}

  step: EliminaStep = EliminaStep.COMPETENZA;
  get title(): string {
    return this.step === EliminaStep.COMPETENZA
      ? 'Eliminazione competenza'
      : 'Eliminazione Abilità e Conoscenze';
  }

  get message(): string {
    return this.step === EliminaStep.COMPETENZA
      ? 'Sei sicuro di voler eliminare la proposta di competenza?'
      : 'Si deve procedere alla cancellazione anche delle relative Abilità e Conoscenze?';
  }

  handleClick(): void {
    this.step === EliminaStep.COMPETENZA
      ? this.handleCompetenzaStep()
      : this.handleAbilitaConoscenzeStep();
  }

  private handleCompetenzaStep(): void {
    this.api
      .checkAbilitaConoscenze({ valore: this.data.idCompetenza })
      .pipe(
        switchMap((res: any) => {
          if (!res.result.booleano) {
            return this.eliminaCompetenza$().pipe(
              tap(() => {
                this.snackBar.open('Competenza eliminata correttamente', 'close', {
                  panelClass: 'successSnack',
                });
                this.dialogRef.close(true);
              }),
            );
          } else {
            this.step = EliminaStep.ASSOCIAZIONI;
            return EMPTY;
          }
        }),
        catchError((error) => {
          console.error('Errore controllo associazioni:', error);
          this.snackBar.open(
            'Errore durante il controllo delle abilità e conoscenze',
            'close',
            {
              panelClass: 'errorSnack',
            },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  private handleAbilitaConoscenzeStep(): void {
    this.api
      .eliminaCompetenzaCascade(this.data.idCompetenza)
      .pipe(
        tap((res: any) => {
          if (res.operation != 3) {
            let message = res.result.message;
            this.snackBar.open(
              message,
              'close',
              { panelClass: ['multi-line-snackbar', 'successSnack'] },
            );
            this.dialogRef.close(true);
          }
        }),
        catchError((error) => {
          console.error('Errore eliminazione abilità e conoscenze:', error);
          this.snackBar.open(
            "Errore durante l'eliminazione delle abilità e conoscenze",
            'close',
            { panelClass: 'errorSnack' },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  private eliminaCompetenza$() {
    return this.api.eliminaCompetenza(this.data.idCompetenza);
  }

  private eliminaCompetenzaDiretta(): void {
    this.eliminaCompetenza$()
      .pipe(
        tap(() => {
          this.snackBar.open('Competenza eliminata correttamente', 'close', {
            panelClass: 'successSnack',
          });
          this.dialogRef.close(true);
        }),
        catchError((error) => {
          console.error('Errore eliminazione competenza:', error);
          this.snackBar.open(
            "Errore durante l'eliminazione della competenza",
            'close',
            {
              panelClass: 'errorSnack',
            },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  closeDialog(refresh: boolean, deletedCascade: boolean = false): void {
    if (this.step === EliminaStep.ASSOCIAZIONI && !deletedCascade) {
      this.snackBar.open(
        'Le abilità e conoscenze non eliminate resteranno associate alle relative competenze ancora esistenti',
        'close',
        { panelClass: 'successSnack' },
      );
    }
    this.dialogRef.close(refresh || this.step === EliminaStep.ASSOCIAZIONI);
  }

  onNoClick(): void {
    if (this.step === EliminaStep.COMPETENZA) {
      this.closeDialog(false);
    } else {
      this.eliminaCompetenzaDiretta();
    }
  }
}
